import {queryOptions} from '@tanstack/react-query'
import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import fetchProductSuggestions from '~/client/spreadshop/old/fetchProductSuggestions'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 10 // 10h

const suggestionsParams = z.object({
    productId: z.string().regex(/[a-z0-9]+-[a-z0-9A-Z]+-[0-9]+-[0-9]+/),
    appearanceId: z.string().optional(),
    locale: z.nativeEnum(Locale).optional(),
})

const getProductSuggestions = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = suggestionsParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }
        return result.data
    })
    .handler(async ({data}) => {
        const {productId, appearanceId, locale} = data

        const suggestions = await fetchProductSuggestions(productId, appearanceId, locale)

        applyServerFnCache(CACHE_TIME_SEC)

        return suggestions
    })

export const productSuggestionsQueryOptions = (
    productId: string,
    appearanceId?: string,
    locale: Locale = Locale.EnEu
) =>
    queryOptions({
        queryKey: [locale, 'suggestions', productId, appearanceId],
        gcTime: CACHE_TIME_SEC * 1000, // 10h
        staleTime: CACHE_TIME_SEC * 1000, // 10h
        queryFn: () => getProductSuggestions({data: {productId, appearanceId, locale}}),
    })
